/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetSerproDataRequest = {
  properties: {
    cpf: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
